import React, { useEffect, useState } from 'react'
import { Backdrop, CircularProgress, Typography } from '@mui/material'
import InfoIcon from '@mui/icons-material/Info'
import DeclarationTable from '../TableNavigable/TableNavigable'
import useStyles from './useStyles'
import BreadcrumbsComponent from '../Breadcrumbs/Breadcrumbs'
import { useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { getSuborganizations } from '../../../redux/actions/Suborganizations'

export const DDJJSuborg = () => {
  const classes = useStyles()
  const [loading, setLoading] = useState(false)
  const { id } = useParams()
  const [suborg, setsuborg] = useState(null)
  const dispatch = useDispatch()

  const getSubOrg = async () => {
    const response = await dispatch(
      getSuborganizations(id)
    )
    if (response) setsuborg(response)
  }

  useEffect(async () => {
    setLoading(true)
    await getSubOrg()
    setLoading(false)
  }, [id])
  return (
      <div className={classes.root}>
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
        >
        <CircularProgress color="inherit" />
      </Backdrop>
        <BreadcrumbsComponent name={suborg ? suborg.suborganizationName : ''}
      />
        <div className={classes.boxtitle}>
          <Typography className={classes.title}>Declaraciones juradas asociadas a {' '}  {suborg ? suborg.suborganizationName : ''}</Typography>
        </div>
        <div className={classes.boxSubTitle}>
          <InfoIcon
            style={{ fontSize: '2rem', color: '#00a78f', marginLeft: 10 }}
          />
          <Typography className={classes.subtitle}>
            En esta sección podrá buscar y/o desbloquear las declaraciones del Estudio asociado a la Organización.
          </Typography>
        </div>
        <div className={classes.containerBody}>
          <div className={classes.boxButtons}></div>
          <DeclarationTable setLoading={setLoading} />
          <div className={classes.boxTable}></div>
        </div>
      </div>
  )
}
